module.exports = __webpack_public_path__ + "static/media/kuppi_boost_trial@2x.497a0568.png";